/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AllExamDetailsResponse } from '../models';
// @ts-ignore
import type { CreateExamBody } from '../models';
// @ts-ignore
import type { CreateExamResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { ExamAutocompleteResponse } from '../models';
// @ts-ignore
import type { FileUploadResponse } from '../models';
// @ts-ignore
import type { IDList } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UpdateExamResponse } from '../models';
/**
 * ExamApiApi - axios parameter creator
 */
export const ExamApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateExamBody} createExamBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        examApiCreateExamDetail: async (createExamBody: CreateExamBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createExamBody' is not null or undefined
            assertParamExists('examApiCreateExamDetail', 'createExamBody', createExamBody)
            const localVarPath = `/admin/exam`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createExamBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IDList} iDList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        examApiDeleteExamDetail: async (iDList: IDList, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iDList' is not null or undefined
            assertParamExists('examApiDeleteExamDetail', 'iDList', iDList)
            const localVarPath = `/admin/exam/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iDList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        examApiExamAutoComplete: async (page?: number, pageSize?: number, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/exam/autocomplete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [examId] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [status] 
         * @param {string} [userSearchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        examApiGetExamDetail: async (examId?: string, pageNo?: number, pageSize?: number, sortBy?: string, sortOrder?: string, status?: string, userSearchQuery?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/exam`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (examId !== undefined) {
                localVarQueryParameter['exam_id'] = examId;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (userSearchQuery !== undefined) {
                localVarQueryParameter['user_search_query'] = userSearchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} examId 
         * @param {CreateExamBody} createExamBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        examApiUpdateExamDetail: async (examId: string, createExamBody: CreateExamBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'examId' is not null or undefined
            assertParamExists('examApiUpdateExamDetail', 'examId', examId)
            // verify required parameter 'createExamBody' is not null or undefined
            assertParamExists('examApiUpdateExamDetail', 'createExamBody', createExamBody)
            const localVarPath = `/admin/exam/{exam_id}`
                .replace('{exam_id}', encodeURIComponent(String(examId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createExamBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} imageFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        examApiUploadExamImage: async (imageFile: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageFile' is not null or undefined
            assertParamExists('examApiUploadExamImage', 'imageFile', imageFile)
            const localVarPath = `/exam/upload-exam-image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (imageFile !== undefined) { 
                localVarFormParams.append('image_file', imageFile as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExamApiApi - functional programming interface
 */
export const ExamApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExamApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateExamBody} createExamBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async examApiCreateExamDetail(createExamBody: CreateExamBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateExamResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.examApiCreateExamDetail(createExamBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamApiApi.examApiCreateExamDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IDList} iDList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async examApiDeleteExamDetail(iDList: IDList, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.examApiDeleteExamDetail(iDList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamApiApi.examApiDeleteExamDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async examApiExamAutoComplete(page?: number, pageSize?: number, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExamAutocompleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.examApiExamAutoComplete(page, pageSize, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamApiApi.examApiExamAutoComplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [examId] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [status] 
         * @param {string} [userSearchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async examApiGetExamDetail(examId?: string, pageNo?: number, pageSize?: number, sortBy?: string, sortOrder?: string, status?: string, userSearchQuery?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllExamDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.examApiGetExamDetail(examId, pageNo, pageSize, sortBy, sortOrder, status, userSearchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamApiApi.examApiGetExamDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} examId 
         * @param {CreateExamBody} createExamBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async examApiUpdateExamDetail(examId: string, createExamBody: CreateExamBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateExamResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.examApiUpdateExamDetail(examId, createExamBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamApiApi.examApiUpdateExamDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} imageFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async examApiUploadExamImage(imageFile: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.examApiUploadExamImage(imageFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamApiApi.examApiUploadExamImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExamApiApi - factory interface
 */
export const ExamApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExamApiApiFp(configuration)
    return {
        /**
         * 
         * @param {ExamApiApiExamApiCreateExamDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        examApiCreateExamDetail(requestParameters: ExamApiApiExamApiCreateExamDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateExamResponse> {
            return localVarFp.examApiCreateExamDetail(requestParameters.createExamBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExamApiApiExamApiDeleteExamDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        examApiDeleteExamDetail(requestParameters: ExamApiApiExamApiDeleteExamDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.examApiDeleteExamDetail(requestParameters.iDList, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExamApiApiExamApiExamAutoCompleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        examApiExamAutoComplete(requestParameters: ExamApiApiExamApiExamAutoCompleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ExamAutocompleteResponse> {
            return localVarFp.examApiExamAutoComplete(requestParameters.page, requestParameters.pageSize, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExamApiApiExamApiGetExamDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        examApiGetExamDetail(requestParameters: ExamApiApiExamApiGetExamDetailRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AllExamDetailsResponse> {
            return localVarFp.examApiGetExamDetail(requestParameters.examId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.status, requestParameters.userSearchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExamApiApiExamApiUpdateExamDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        examApiUpdateExamDetail(requestParameters: ExamApiApiExamApiUpdateExamDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateExamResponse> {
            return localVarFp.examApiUpdateExamDetail(requestParameters.examId, requestParameters.createExamBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExamApiApiExamApiUploadExamImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        examApiUploadExamImage(requestParameters: ExamApiApiExamApiUploadExamImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<FileUploadResponse> {
            return localVarFp.examApiUploadExamImage(requestParameters.imageFile, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for examApiCreateExamDetail operation in ExamApiApi.
 */
export interface ExamApiApiExamApiCreateExamDetailRequest {
    readonly createExamBody: CreateExamBody
}

/**
 * Request parameters for examApiDeleteExamDetail operation in ExamApiApi.
 */
export interface ExamApiApiExamApiDeleteExamDetailRequest {
    readonly iDList: IDList
}

/**
 * Request parameters for examApiExamAutoComplete operation in ExamApiApi.
 */
export interface ExamApiApiExamApiExamAutoCompleteRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly query?: string
}

/**
 * Request parameters for examApiGetExamDetail operation in ExamApiApi.
 */
export interface ExamApiApiExamApiGetExamDetailRequest {
    readonly examId?: string

    readonly pageNo?: number

    readonly pageSize?: number

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly status?: string

    readonly userSearchQuery?: string
}

/**
 * Request parameters for examApiUpdateExamDetail operation in ExamApiApi.
 */
export interface ExamApiApiExamApiUpdateExamDetailRequest {
    readonly examId: string

    readonly createExamBody: CreateExamBody
}

/**
 * Request parameters for examApiUploadExamImage operation in ExamApiApi.
 */
export interface ExamApiApiExamApiUploadExamImageRequest {
    readonly imageFile: File
}

/**
 * ExamApiApi - object-oriented interface
 */
export class ExamApiApi extends BaseAPI {
    /**
     * 
     * @param {ExamApiApiExamApiCreateExamDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public examApiCreateExamDetail(requestParameters: ExamApiApiExamApiCreateExamDetailRequest, options?: RawAxiosRequestConfig) {
        return ExamApiApiFp(this.configuration).examApiCreateExamDetail(requestParameters.createExamBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExamApiApiExamApiDeleteExamDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public examApiDeleteExamDetail(requestParameters: ExamApiApiExamApiDeleteExamDetailRequest, options?: RawAxiosRequestConfig) {
        return ExamApiApiFp(this.configuration).examApiDeleteExamDetail(requestParameters.iDList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExamApiApiExamApiExamAutoCompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public examApiExamAutoComplete(requestParameters: ExamApiApiExamApiExamAutoCompleteRequest = {}, options?: RawAxiosRequestConfig) {
        return ExamApiApiFp(this.configuration).examApiExamAutoComplete(requestParameters.page, requestParameters.pageSize, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExamApiApiExamApiGetExamDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public examApiGetExamDetail(requestParameters: ExamApiApiExamApiGetExamDetailRequest = {}, options?: RawAxiosRequestConfig) {
        return ExamApiApiFp(this.configuration).examApiGetExamDetail(requestParameters.examId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.status, requestParameters.userSearchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExamApiApiExamApiUpdateExamDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public examApiUpdateExamDetail(requestParameters: ExamApiApiExamApiUpdateExamDetailRequest, options?: RawAxiosRequestConfig) {
        return ExamApiApiFp(this.configuration).examApiUpdateExamDetail(requestParameters.examId, requestParameters.createExamBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExamApiApiExamApiUploadExamImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public examApiUploadExamImage(requestParameters: ExamApiApiExamApiUploadExamImageRequest, options?: RawAxiosRequestConfig) {
        return ExamApiApiFp(this.configuration).examApiUploadExamImage(requestParameters.imageFile, options).then((request) => request(this.axios, this.basePath));
    }
}

